import type { IMetadataKeyRepository, ISettingsRepository } from '@app/domain/ports';
import { LocalStorageMetadataKeyRepository, SettingsRepository } from '../repositories';

/**
 * Factory for creating localStorage-based repositories.
 * Handles repositories that depend on browser localStorage.
 *
 * Note: Creates plain repository without encryption.
 * Encryption should be added via decorator in application layer.
 */
export class LocalStorageRepositoryFactory {
  createSettingsRepository(): ISettingsRepository {
    return new SettingsRepository();
  }

  createMetadataKeyRepository(): IMetadataKeyRepository {
    return new LocalStorageMetadataKeyRepository();
  }
}
